import withLoader from "../../../components/layouts/WithLoader"
import { useState } from "react";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import SalesService from "../../../services/SellingService";
import ListBanquesToPayement from "../../../models/ListBanquesToPayement";
import TierAccountService from "../../../services/PayementSolde/TierAccountService";
import { useNavigate } from "react-router-dom";
import BankService from "../../../services/PosService/BankService";
import UtilsFormule from "../../../utils/UtilsFormule";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import UploadAndDownloadService from "../../../services/uploadAndDownloadFile";

const styles = {
    container: (base) => ({
        ...base,
        flex: 1,
    }),
};

const ChargerWalletEnLign = ({ startLoading, stopLoading }) => {
    const navigate = useNavigate();
    const animatedComponents = makeAnimated();

    const [openInfoAlert, setOpenInfoAlert] = useState(false);
    const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
    const [successAlertText, setSuccessAlertText] = useState();
    const [infoAlertText, setInfoAlertText] = useState();
    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState();
    const [amount, setAmount] = useState();
    const [refEnLigne, setRefEnLigne] = useState("");

    const [searchPay, setSearchPay] = useState("");
    const [listSearchPay, setListSearchPay] = useState([]);
    const [isSearchPay, setIsSearchPay] = useState(false);
    const [disableInputs, setDisableInputs] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [payementSelectPlaceHolder, setPayemenSelectPlaceHolder] =
        useState("Choisir...");
    const [fileName, setFileName] = useState("");
    const [file, setFile] = useState([]);

    const changeAmount = (event) => {
        setAmount(event.target.value);
    };

    const handleInfoClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenInfoAlert(false);
    };

    const handleSuccessClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSuccessAlert(false);
    };
    const handleEroorClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenErrorAlert(false);
    };

    const searchPayement = () => {
        startLoading();
        BankService.searchPayementByRef(getCurrentUserId(), 1, searchPay).then((response) => {

            let backendData = [{}];

            response.data.success.map((element) => {
                let elem = {
                    value: element["ref"], label: element["ref"] + "-" + element["amountPayed"], customElements: {
                        amount: element["amountPayed"],

                    }
                };
                backendData.push(elem);
            })
            setListSearchPay(backendData)
            setIsSearchPay(true)
            console.log(response)
        }).catch((e) => {
            console.log(e)

        }).finally(() => {
            stopLoading();
        })

    }
    const payerBill = (e) => {

        const url = window.location.pathname.split("/")[1];
        if (url === "chargerWallet") {
            if (amount === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Le montant est vide ");
            } else {
                let walletModel = {
                    idUser: getCurrentUserId(),
                    idBa: parseInt(localStorage.getItem("banqueAccount")),
                    idWallet: parseInt(sessionStorage.getItem("idWallet")),
                    typePayement: 1,
                    urlFile: "any",
                    ammountPayed: amount,
                };
                if (file.length !== 0) {
                    const uploadData = new FormData();
                    uploadData.append("picture", file);
                    startLoading();
                    UploadAndDownloadService.uploadFile(
                        "/sales/uploadFileSelling/uploadFile/Payement",
                        uploadData
                    )
                        .then((response) => {
                            if (response.data["success"]) {
                                walletModel.urlFile = response.data.success;
                                TierAccountService.addWalletPayement(walletModel)
                                    .then((response) => {
                                        console.log(response);
                                        if (response.data["error"]) {
                                            setOpenErrorAlert(true);
                                            setErrorAlertText("Erreur :  " + response.data["error"]);
                                        } else {
                                            setOpenSuccessAlert(true);
                                            setSuccessAlertText("Enregistrement avec succées");
                                            setTimeout(() => {
                                                navigate(`/walletClient`);
                                            }, 2000);
                                        }
                                    })
                                    .catch((error) => {
                                        setOpenErrorAlert(true);
                                        setErrorAlertText("Erreur :  " + error);
                                    })
                            } else {
                            }
                        })
                        .catch((error) => {
                            setOpenErrorAlert(true);
                            setErrorAlertText("Erreur :  " + error);
                        })
                        .finally(() => {
                            stopLoading();
                        });

                } else {
                    startLoading();
                    TierAccountService.addWalletPayement(walletModel)
                        .then((response) => {
                            console.log(response);
                            if (response.data["error"]) {
                                setOpenErrorAlert(true);
                                setErrorAlertText("Erreur :  " + response.data["error"]);
                            } else {
                                setOpenSuccessAlert(true);
                                setSuccessAlertText("Enregistrement avec succées");
                                setTimeout(() => {
                                    navigate(`/walletClient`);
                                }, 2000);
                            }
                        })
                        .catch((error) => {
                            setOpenErrorAlert(true);
                            setErrorAlertText("Erreur :  " + error);
                        })
                        .finally(() => {
                            stopLoading();
                        });
                }

            }
        } else if (url === "chargerWalletFournisseur") {

            if (amount === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Le montant est vide ");
            } else {
                let walletModel = {
                    idUser: getCurrentUserId(),
                    idBa: parseInt(localStorage.getItem("banqueAccount")),
                    idWallet: parseInt(sessionStorage.getItem("idWallet")),
                    typePayement: 1,
                    ammountPayed: amount,
                    refEnLigne: refEnLigne,
                    urlFile: "any",

                };

                if (file.length !== 0) {
                    const uploadData = new FormData();
                    uploadData.append("picture", file);
                    startLoading();
                    UploadAndDownloadService.uploadFile(
                        "/retail/uploadFile/uploadFile/Payement",
                        uploadData
                    )
                        .then((response) => {
                            if (response.data["success"]) {
                                walletModel.urlFile = response.data.success;
                                TierAccountService.addWalletPayementFournisseur(walletModel)
                                    .then((response) => {
                                        console.log(response);
                                        if (response.data["error"]) {
                                            setOpenErrorAlert(true);
                                            setErrorAlertText("Erreur :  " + response.data["error"]);
                                        } else {
                                            setOpenSuccessAlert(true);
                                            setSuccessAlertText("Enregistrement avec succées");
                                            setTimeout(() => {
                                                navigate(`/walletFournisseur`);
                                            }, 2000);
                                        }
                                    })
                                    .catch((error) => {
                                        setOpenErrorAlert(true);
                                        setErrorAlertText("Erreur :  " + error);
                                    })



                            } else {
                            }
                        })
                        .catch((error) => {
                            setOpenErrorAlert(true);
                            setErrorAlertText("Erreur :  " + error);
                        })
                        .finally(() => {
                            stopLoading();
                        });
                } else {

                    startLoading();
                    TierAccountService.addWalletPayementFournisseur(walletModel)
                        .then((response) => {
                            console.log(response);
                            if (response.data["error"]) {
                                setOpenErrorAlert(true);
                                setErrorAlertText("Erreur :  " + response.data["error"]);
                            } else {
                                setOpenSuccessAlert(true);
                                setSuccessAlertText("Enregistrement avec succées");
                                setTimeout(() => {
                                    navigate(`/walletFournisseur`);
                                }, 2000);
                            }
                        })
                        .catch((error) => {
                            setOpenErrorAlert(true);
                            setErrorAlertText("Erreur :  " + error);
                        })
                        .finally(() => {
                            stopLoading();
                        });
                }


            }
        }
    };
    const changeSearchPay = (event) => {
        setSearchPay(event.target.value);
    };

    const changeRefEnLigne = (event) => {
        setRefEnLigne(event.target.value);
    };
    const onChangeSelectedCheque = (selectedOptionn) => {
        setSelectedOption();
        setPayemenSelectPlaceHolder(selectedOptionn.label);
        setAmount(selectedOptionn.customElements.amount);
        setRefEnLigne(selectedOptionn.value);
        setDisableInputs(true);

    };
    const onUploadFileHandler = (e) => {
        if (e.target.files[0].size > 2097152) {
            setOpenInfoAlert(true);
            setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
        } else {
            setFileName(e.target.files[0].name);

            setFile(e.target.files[0]);
        }
    };
    return (
        <>

            <div className="row">
                <div className="col-12">
                    <label>Charger le wallet en ligne: </label>
                </div>
            </div>
            <div className="input-group">
                <div
                    className="input-group-prepend"
                    style={{ width: "95%" }}
                >
                    <input
                        value={searchPay}
                        onChange={changeSearchPay}
                        class="form-control"
                        placeholder="chercher payement"
                        type="text"
                    />
                </div>
                <div className=" input-group-append">
                    <button
                        onClick={searchPayement}
                        type="button"
                        class="btn btn-dark"
                    >
                        <i class="fas  fa-solid fa-arrow-down"></i>
                    </button>
                </div>
            </div>
            <br />
            {isSearchPay && <Select
                styles={styles}
                closeMenuOnSelect={true}
                components={animatedComponents}
                defaultValue={selectedOption}
                onChange={onChangeSelectedCheque}
                options={listSearchPay}
                placeholder={payementSelectPlaceHolder}
            />}
            <div class="row">
                <div class="col-md-4">
                    <label>Montant : </label>
                    <input
                        type="number"
                        min="0"
                        step="0.1"
                        //   max={this.props.restToPay.toString()}
                        class="form-control"
                        placeholder="Montant "
                        name="amount"
                        value={amount}
                        onChange={changeAmount}
                        disabled={disableInputs}

                    />
                </div>
                <div class="col-md-4">
                    <label>réference : </label>

                    <input
                        value={refEnLigne}
                        onChange={changeRefEnLigne}
                        class="form-control"
                        placeholder="Ref En ligne"
                        type="text"
                        disabled={disableInputs}

                    />
                </div>
                <div class="col-md-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div class="form-group">
                                <label for="exampleInputFile">Ajouter TPE </label>
                                <div class="input-group">
                                    <div class="custom-file">
                                        <input
                                            accept="application/pdf, .jpg, .jpeg, .png"
                                            type="file"
                                            className="custom-file-input"
                                            id="exampleInputFile"
                                            onChange={onUploadFileHandler}
                                        />
                                        <label class="custom-file-label" for="exampleInputFile">
                                            {fileName}{" "}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <label>Compte bancaire </label>
                    <ListBanquesToPayement type={1} />
                </div>
                <div class="col-12">
                    <button
                        type="submit"
                        onClick={payerBill}
                        className="btn btn-dark float-right"
                    >
                        Payer
                    </button>
                </div>
            </div>
            <Snackbar
                open={openSuccessAlert}
                autoHideDuration={2000}
                onClose={handleSuccessClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleSuccessClose} severity="success">
                    {successAlertText}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openErrorAlert}
                autoHideDuration={2000}
                onClose={handleEroorClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleEroorClose} severity="error">
                    {errorAlertText}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openInfoAlert}
                autoHideDuration={4000}
                onClose={handleInfoClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert onClose={handleInfoClose} severity="info">
                    {infoAlertText}
                </Alert>
            </Snackbar>
        </>
    );


}

export default withLoader(ChargerWalletEnLign)